import { isTemplate } from '@helpers/getDocumentMode';
import { DocumentDuplicateIcon, TemplateIcon } from '@heroicons/react/solid';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';
import clsx from 'clsx';

const classes = clsx(
  'inline-flex',
  'items-center',
  'gap-x-1.5',
  'rounded-xl',
  'bg-gray-100',
  'px-3',
  'py-1',
  'text-xs',
  'font-medium',
  'text-gray-800',
);

const iconClasses = clsx('h-4', 'w-4', 'shrink-0');

export const getBaseAccessor = <T extends { sourceResourceName: string }>(columnHelper: ColumnHelper<T>) =>
  columnHelper.accessor((entity) => entity.sourceResourceName, {
    id: 'sourceResourceName',
    header: 'Base',
    filterFn: (row, _, value) => row.original.sourceResourceName === value,
    cell: (cellContext: CellContext<T, string>) => {
      const sourceResourceName = cellContext.getValue();
      if (!sourceResourceName) {
        return null;
      }

      const icon = isTemplate(sourceResourceName) ? (
        <TemplateIcon className={iconClasses} />
      ) : (
        <DocumentDuplicateIcon className={iconClasses} />
      );

      const label = isTemplate(sourceResourceName) ? 'Template' : 'Contract';

      return (
        <span className={clsx(classes)}>
          {icon}
          {label}
        </span>
      );
    },
    meta: {
      filter: {
        isSingleSelection: true,
        placeholder: 'All bases',
        optionsMapping: [
          { label: 'Contract', value: 'submissions' },
          { label: 'Template', value: 'templates' },
        ],
      },
    },
  });
